export default __webpack_public_path__ + "b02603a221e34873be21c5456e471af6.webp";